import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import { createValidator, ErrorObject, required } from 'util/validation'
import { isEmpty } from 'util/validation/Util'
import { desfechoOdontoValidator } from 'view/atendimentos/detail/soap/desfecho/validator/validatorOdonto'

import { DesfechoFormModel } from './DesfechoForm'

const desfechoIndividualValidator = () =>
  createValidator<DesfechoFormModel>(
    {
      tipoAtendimento: [required],
    },
    (values: DesfechoFormModel, errors: ErrorObject<DesfechoFormModel>) => {
      if (isEmpty(values.fichasNotifiacaoCasoSuspeito)) {
        errors.conduta = required(values.conduta)
      }

      return errors
    }
  )

export const desfechoValidator = (tipoAtendProf: TipoAtendimentoProfissional, isDemandaEspontanea: boolean) =>
  tipoAtendProf === TipoAtendimentoProfissional.ATENDIMENTO_ODONTOLOGICO
    ? desfechoOdontoValidator(isDemandaEspontanea)
    : desfechoIndividualValidator()
